<script setup>
import { computed, inject } from 'vue';
import { styleVars } from './shared.js';
import { shopItems } from '../shop.js';
import SiteShop from '../SiteShop.vue';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

// No products is no block for a visitor, heading included; the editor
// keeps SiteShop's hint (Mus, 2026-10-11).
const editing = inject('tiqEditorCanvas', false);
const hasItems = computed(() => editing || shopItems(props.config).length > 0);
</script>

<template>
    <section v-if="hasItems" :id="config.anchor_id || null" class="th-block th-sec th-shop" :style="styleVars(config)">
        <div class="th-wrap">
            <div v-if="config.eyebrow || config.heading || config.intro" class="th-shop__head">
                <p v-if="config.eyebrow" class="th-eyebrow">{{ config.eyebrow }}</p>
                <h2 v-if="config.heading" class="th-h2">{{ config.heading }}</h2>
                <p v-if="config.intro" class="th-shop__intro">{{ config.intro }}</p>
            </div>
            <SiteShop class="th-shop__grid" :config="config" :site_data="site_data" />
        </div>
    </section>
</template>

<style scoped>
.th-shop__head { margin-bottom: clamp(18px, 2.5vw, 28px); }
.th-shop__intro { margin: 12px 0 0; font-size: 17px; color: var(--text-sub, var(--th-muted)); max-width: 60ch; text-wrap: pretty; }
.th-shop__grid {
    --shop-radius: var(--r);
    --shop-btn-radius: 999px;
    --shop-line: var(--th-line);
    --shop-muted: var(--th-meta);
    --shop-photo-bg: var(--th-line-soft, #efece4);
    --shop-btn-bg: var(--btn-bg, var(--accent));
    --shop-btn-text: var(--btn-text, #fff);
    --shop-heading: var(--text-heading, var(--th-ink));
}
.th-shop__grid :deep(.tiq-shop__name) { font-family: var(--th-display); font-weight: 800; letter-spacing: -0.01em; }
.th-shop__grid :deep(.tiq-shop__price) { font-family: var(--th-mono); font-weight: 600; }
.th-shop__grid :deep(.tiq-shop__options li) { font-family: var(--th-mono); font-weight: 500; }
</style>
